{
  "id": "set",
  "pantheon": "egyptians",
  "name": {
    "pt-BR": "Set",
    "en": "Set"
  },
  "icon": "gods/set",
  "portrait": "gods/set-portrait",
  "modifiers": [
    {
      "target": "cost",
      "op": "mul",
      "value": 0.75,
      "scope": {
        "ids": ["barracks", "siege-works", "migdol-stronghold"],
        "resources": ["gold"]
      },
      "note": "Barracks, Siege Works and Migdol Strongholds cost -25% Gold."
    },
    {
      "target": "cost",
      "op": "mul",
      "value": 0.9,
      "scope": {
        "ids": ["spearman", "axeman", "slinger", "chariot-archer", "camel-rider", "war-elephant"]
      },
      "condition": "custom",
      "note": "Units trained in a Barracks/Migdol Stronghold within 20 of a Monument cost -10% (Devotees aura)."
    }
  ],
  "startExtras": {
    "units": {
      "baboon-of-set": 1
    }
  },
  "powers": ["vision"],
  "minors": {
    "classical": ["anubis", "ptah"],
    "heroic": ["nephthys", "sekhmet"],
    "mythic": ["horus", "thoth"]
  },
  "unlocks": [
    "clairvoyance",
    "baboon-of-set",
    "hyena-of-set",
    "gazelle-of-set",
    "giraffe-of-set",
    "crocodile-of-set",
    "hippopotamus-of-set",
    "rhinoceros-of-set",
    "elephant-of-set"
  ],
  "meta": {
    "source": "Game files 19.17020 (major_gods.xml, techtree.xml, string_replacement_values.xml, string_table.txt)",
    "checkedAt": "2026-10-18",
    "confidence": "high",
    "note": "Other bonuses: Pharaoh summons Animals of Set (Favor); Priests convert wild animals (-25% Food); +5% speed for Spearmen, Axemen, Slingers. Free animals on age-up (not expressible): Classical 1 Hyena + 2 Gazelles of Set, Heroic 1 Crocodile + 2 Giraffes of Set, Mythic 1 Rhinoceros + 2 Hippopotamuses of Set (spawn at a Temple). Vision recharge 240 s."
  },
  "fieldMeta": {
    "modifiers": {
      "source": "Game files 19.17020 (techtree.xml)",
      "checkedAt": "2026-10-18",
      "confidence": "high",
      "note": "ArchaicAgeSet: Barracks/Migdol Stronghold/Siege Works gold x0.75 Percent; starts with 1 Baboon of Set (major_gods.xml)."
    }
  }
}
